export default {
  "copyright": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["University Of Georgia ©"])},
  "login": {
    "authorization": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authorization"])},
    "sign-in": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sign in to your account"])},
    "code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code"])},
    "password": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Password"])},
    "login": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Login"])},
    "forgot-password": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Forgot Password?"])}
  },
  "header": {
    "search": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search"])}
  },
  "study-office-information": {
    "student": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["სტუდენტი Eng"])},
    "personal_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["პირადი N"])},
    "program": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["პროგრამა"])},
    "school": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["სკოლა"])},
    "level": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["საფეხური"])},
    "category": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["საფეხური"])}
  },
  "evaluations": {
    "group": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Group"])},
    "day": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Day"])},
    "time": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Time"])},
    "subject": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Subject"])},
    "lector": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lecturer"])},
    "student-count": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Students count"])}
  }
}